import Reveal from "../Reveal";

export default function Problem() {
  return (
    <section
      id="problem"
      data-testid="problem-section"
      className="py-24 md:py-36 border-t border-[#E2DCD0]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20">
          <Reveal className="lg:col-span-5">
            <p className="text-[11px] uppercase tracking-[0.3em] font-semibold text-[#C86A53] mb-8">
              01 — The Problem
            </p>
            <h2
              data-testid="problem-headline"
              className="font-display font-light tracking-tighter leading-[0.95] text-[#0F172A] text-5xl md:text-6xl lg:text-7xl"
            >
              Doing great work <br /> isn't always <br /> <span className="italic">enough.</span>
            </h2>
          </Reveal>

          <Reveal delay={0.1} className="lg:col-span-6 lg:col-start-7 lg:pt-6">
            <div className="space-y-6 text-lg md:text-xl leading-relaxed font-light text-[#475569]">
              <p>
                Many businesses reach a point where growth starts to slow.
              </p>
              <p>
                Not because the product isn't good or the service isn't strong.
                But because customers, teams and stakeholders don't fully understand
                the value being created.
              </p>
              <p className="text-[#0F172A] font-normal italic font-display text-2xl md:text-3xl pt-4 border-t border-[#E2DCD0]">
                The story isn't landing.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
